import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'

export default function UserForm({userdata, classes, title, submitHandler}) {
  const [values, setValues] = React.useState({
    first_name: userdata.first_name,
    last_name: userdata.last_name,
    enterprise: userdata.last_name,
    profession: userdata.profession,
    domain_activity: userdata.domain_activity,
  })

  /* React.useEffect(
    () => {
      if (userdata) {
        setValues({
          first_name: userdata.first_name,
          last_name: userdata.last_name,
          enterprise: userdata.last_name,
          profession: userdata.profession,
          domain_activity: userdata.domain_activity,
        })
      }
    }, [userdata]
  ) */

  const handleSubmit = (e) => {
    e.preventDefault()
    if (typeof submitHandler == 'function') {
      submitHandler(values)
    }
  }

  const handleChange = (field) => (e) => {
    setValues(x => {
      return {
        ...x,
        [field]: e.target.value
      }
    })
  }

  return (
    <React.Fragment>
      {title && <Typography variant="h6" gutterBottom>
        {title}
      </Typography>}
      {values && <form noValidate autoComplete="off">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="firstName"
            name="firstName"
            label="Prénom"
            value={values.first_name}
            fullWidth
            // autoComplete="given-name"
            onChange={handleChange('first_name')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="lastName"
            name="lastName"
            label="Nom"
            value={values.last_name}
            fullWidth
            // autoComplete="family-name"
            onChange={handleChange('last_name')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="enterprise"
            name="enterprise"
            label="Entreprise"
            value={values.enterprise}
            fullWidth
            // autoComplete="enterprise"
            onChange={handleChange('enterprise')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="profession"
            name="profession"
            label="Profession"
            value={values.profession}
            fullWidth
            // autoComplete="profession"
            onChange={handleChange('profession')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="domain_activity"
            name="domain_activity"
            label="Domaine d'activité"
            value={values.domain_activity}
            fullWidth
            // autoComplete="domain-activity"
            onChange={handleChange('domain_activity')}
          />
        </Grid>
        <Grid item xs={12}>
          <Link
            component='button'
            color="primary"
            style={{textDecoration: 'none', float: 'right'}}
            onClick={handleSubmit}
          >
            Valider
          </Link>
        </Grid>
      </Grid>
      </form>}
    </React.Fragment>
  );
}